module.exports = __webpack_public_path__ + "static/img/master_studio_member_3.6ae77f7.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/homepage/img/master_studio_member_3.png
// module id = ltIi
// module chunks = 11